/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupremove1Inputs */

const en_signupremove1 = /** @type {(inputs: Signupremove1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove question`)
};

const de_signupremove1 = /** @type {(inputs: Signupremove1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frage entfernen`)
};

/**
* | output |
* | --- |
* | "Remove question" |
*
* @param {Signupremove1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupremove1 = /** @type {((inputs?: Signupremove1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupremove1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupremove1(inputs)
	return de_signupremove1(inputs)
});
export { signupremove1 as "signupRemove" }